module.exports = __webpack_public_path__ + "img/ball_2.8d55947b.svg";